import * as yup from 'yup';

const companyFinepFormSchema = yup.object().shape({
  cnpj: yup.string().required(),
  abbreviation: yup.string().optional(),
  tradeName: yup.string().required(),
  legalName: yup.string().required(),
  legalType: yup.string().optional(),
  cnaeCode: yup.string().optional(),
  website: yup.string().optional(),
  updatedCapital: yup.number().nullable(),
  foundationDate: yup.date().nullable(true),
  // .transform((_, val) => val),
  operationStartDate: yup.date().nullable(true),
  revenueOpeningDate: yup.date().nullable(true),
  hasCommercialRegistration: yup.number().optional(),
  hasStateRegistration: yup.number().optional(),
  hasCivilRegistration: yup.number().optional(),
  isExecutor: yup.number().optional(),
});

export default companyFinepFormSchema;